export default __webpack_public_path__ + "static/media/ModalImage5.1fd687d1.jpg";